/** The 429 body every blocked school AI call returns (see the backend AI credit gate). */
export interface AiLimitPayload {
  code?: 'ai_limit_reached';
  ai_limit_reached: true;
  limit_scope?: 'school' | 'user';
  detail?: string;
  options?: { buy_credit?: boolean; own_key?: boolean };
  wallet?: { balance_credits: string; has_key: boolean };
  monthly_limit_usd?: number | string;
  monthly_spent_usd?: number | string;
}

export const AI_LIMIT_EVENT = 'yada:ai-limit';

const isBody = (v: unknown): v is AiLimitPayload =>
  !!v && typeof v === 'object'
  && ((v as { ai_limit_reached?: unknown }).ai_limit_reached === true
    || (v as { code?: unknown }).code === 'ai_limit_reached');

/**
 * The limit payload carried by an axios error (`response.data`), a coach stream error (`data`),
 * or a bare 429 body; null for anything else.
 */
export function isAiLimit(errOrBody: unknown): AiLimitPayload | null {
  if (!errOrBody || typeof errOrBody !== 'object') return null;
  const e = errOrBody as { response?: { status?: number; data?: unknown }; data?: unknown; status?: number };
  const fromResponse = e.response && (e.response.status === undefined || e.response.status === 429) ? e.response.data : undefined;
  const fromData = e.status === undefined || e.status === 429 ? e.data : undefined;
  for (const candidate of [fromResponse, fromData, errOrBody]) {
    if (isBody(candidate)) return candidate;
  }
  return null;
}

export function emitAiLimit(payload: AiLimitPayload): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<AiLimitPayload>(AI_LIMIT_EVENT, { detail: payload }));
}

/** Open the "AI credit ended" dialog if this error is a blocked-AI 429. Never throws. */
export function notifyAiLimitFromError(error: unknown): void {
  const payload = isAiLimit(error);
  if (payload) emitAiLimit(payload);
}
